import axios from 'axios';

const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
});

export const submitLead = (data) => publicApi.post('/api/leads/demo-request', data);
